<template>
  <div class="top-container">

    <div class="success-banner-container">
      <p class="banner-title">You’ve successfully cast your vote!</p>
      <p class="banner-text">See the on-chain vote <strong>here.</strong></p>
      <p class="banner-text">Thank you for casting your vote and contributing to the VIBES community DAO. You can check back here once the voting period has ended to see the result of the proposal.</p>
    </div>

    <div class="voting-container">
        <img class="vote-image" src="@/assets/vote-for.png">
        <img class="vote-image" src="@/assets/vote-against.png">
    </div>

    <div class="votes-text">
      47 votes so far
    </div>

  </div>
</template>

<script>

export default {
  name: 'Voting',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {

  },
  async mounted () {
  },
  beforeDestroy () {
  }
}
</script>

<style lang="scss" scoped>

.voting-container{
  display: flex;
  justify-content: space-around;
}

.vote-image{
  cursor: pointer;
}

.votes-text{
  margin-top: 20px;
  color: #000;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.success-banner-container{
  background-color: rgba(173, 246, 177, 0.50);
  padding: 14px 20px;
  border-radius: 4px;
  stroke-width: 1px;
  stroke: #ADF6B1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.banner-title{
  color: #000;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.banner-text{
  color: #000;
  font-size:12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: center;
}

strong{
  text-decoration: underline;
  cursor: pointer;
}

@media (max-width: 760px) {
  .title{
    font-size: 14px;
  }
  .image{
    height: 40px;
    width: 40px;
    border-radius: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dao-community/proposal/voting.vue